<microsec-card [isDetailCard]="true">
  <p-tabs class="microsec-dashboard-tab" [value]="0">
    <p-tablist>
      <p-tab [value]="0">Overview</p-tab>
      <p-tab [value]="1">Assigned Devices</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel [value]="0">
        <app-firmware-overview [firmware]="firmware" />
      </p-tabpanel>
      <p-tabpanel [value]="1">
        <app-firmware-assigned-devices [firmware]="firmware" (refreshFirmwareEvent)="refreshFirmware()" />
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</microsec-card>
